/* eslint-disable prefer-const */
<template>
    <section class="workflow-configs" :class="{ loading, ready: !loading }">
        <dd>
            <data-viewer
                :item="processVariable"
                :title="$t('dj-运行参数')"
                class="configs-container"
                v-if="processVariable"
            />
            <div v-else class="no-data">{{ $t("dj-暂无数据") }}</div>
        </dd>
    </section>
</template>

<script>
import api from '@/api';
import { DataViewer } from '@/components';
import { getJsonStringObject } from '@/helpers';

export default {
    name: 'workflow-configs',
    props: ['clusterName', 'workflowId', 'runId'],
    data() {
        return {
            loading: false,
            processVariable: null,
        };
    },
    components: {
        'data-viewer': DataViewer,
    },
    async created() {
        await this.fetchWorkflowInfo();
    },
    mounted() {},
    beforeDestroy() {},
    methods: {
        async fetchWorkflowInfo() {
            const pam = {
                wid: this.workflowId,
                rid: this.runId,
                pageNo: 1,
                pageSize: 5,
            };
            this.loading = true;
            const res = await api.getWorkflows(pam);
            this.loading = false;
            if (res.status === 200 && res.data.response) {
                const { content } = res.data.response;
                const { processVariable } = content[0];
                // eslint-disable-next-line prefer-const
                if (processVariable) {
                    const pv = processVariable;
                    pv.scConfigVariable = getJsonStringObject(
                        processVariable.scConfigVariable,
                    );
                    pv.abnormalInfos = getJsonStringObject(processVariable.abnormalInfos);
                    this.processVariable = getJsonStringObject(pv);
                }
            } else {
                this.$message.error('查询workflow信息失败！');
                return;
            }
        },
    },
    watch: {},
};
</script>


<style lang="stylus">
@require '../../styles/definitions.styl';

section.workflow-configs {
  display: flex;
  flex: auto;
  flex-direction: column;

  &.loading section.results table {
    opacity: 0.7;
  }
}
</style>
<style lang="less" scoped>
.configs-container {
  width: 100%;
  height: 70vh;
}
.no-data {
  width:100%;
  height: 80vh;
  padding: 40px;
}
::v-deep .data-viewer:not(.overflow) a.view-full-screen {
    display: block;
}
</style>
